import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMergedSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMergedSimple"><Path d="M6 2C8.20914 2 10 3.79086 10 6C10 7.84713 8.74759 9.40042 7.0459 9.86035C7.44481 13.591 10.4081 16.5537 14.1387 16.9531C14.5988 15.2518 16.1531 14 18 14C20.2091 14 22 15.7909 22 18C22 20.2091 20.2091 22 18 22C16.1211 22 14.5455 20.7044 14.1162 18.958C11.2088 18.7033 8.65829 17.2075 7 15V21.5H5V9.87402C3.27477 9.42998 2 7.86384 2 6C2 3.79086 3.79086 2 6 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMergedSimple;
